export const ASSUMPTION_ALLOW = "1";
export const ASSUMPTION_NOT_ALLOW = "2";

export const SERVICING_SERVICE = "1";
export const SERVICING_TRANSFER = "2";
